/** Read the import plan from an actual API rejection, never from a transport error. */
import { ApiError } from '../../_shared/api-error';
import type { ImportPlanResponse } from './types';

/** A validation conflict carries a plan; a changed summary has a valid new plan. */
export function importFailureOf(error: unknown): { plan: ImportPlanResponse | null; summaryChanged: boolean } {
  const body = error instanceof ApiError ? error.body : null;
  const candidate = body && typeof body === 'object' && 'plan' in body ? body.plan : null;
  const value = candidate as Partial<ImportPlanResponse> | null;
  const plan = value && typeof value === 'object' && value.summary?.cohorts && value.summary.users && value.summary.cohortAssignments &&
    ['cohortOps', 'userOps', 'worldOps', 'sessionOps', 'campaignOps', 'errors', 'warnings'].every(key => Array.isArray(value[key as keyof ImportPlanResponse]))
    ? value as ImportPlanResponse : null;
  return { plan, summaryChanged: error instanceof ApiError && error.status === 409 && !!plan && plan.errors.length === 0 };
}
